import React from 'react';

const LocationMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.68618C0 3.88894 4.17868 0 9.33333 0C14.488 0 18.6667 3.88894 18.6667 8.68618C18.6667 13.4458 15.6878 18.9999 11.0401 20.9861C9.95663 21.4491 8.71003 21.4491 7.62658 20.9861C2.97888 18.9999 0 13.4458 0 8.68618ZM9.33333 12C10.8061 12 12 10.8061 12 9.33333C12 7.86057 10.8061 6.66667 9.33333 6.66667C7.86057 6.66667 6.66667 7.86057 6.66667 9.33333C6.66667 10.8061 7.86057 12 9.33333 12Z"
        fill="white"
      />
    </svg>
  );
};

export default LocationMarkIcon;
